import React from 'react';
import Header from '../../exemplos/Header/Header';
import Footer from '../../exemplos/Footer/Footer';

import styles from './LayoutNotLogged.module.scss';

const LayoutNotLogged: React.FC = ({ children }) => (
  <>
    <Header />
    <section className={styles.container}>
      { children }
    </section>
    <Footer />
  </>
);

export default LayoutNotLogged;
